import React from 'react';
import { 
  TrendingUp, 
  BookOpen, 
  GraduationCap, 
  BarChart3, 
  Headphones,
  Lightbulb,
  Target,
  Compass,
  HelpCircle
} from 'lucide-react';
import Header from '../Header';
import Footer from '../Footer';

const KnowledgeData = [
  {
    id: 'insights',
    title: 'Insights: Wealth Blog',
    description: 'In-depth analysis on wealth creation strategies',
    Icon: Lightbulb,
    category: 'Blogs & Podcast',
    externalLink: 'https://maxiomwealth.com/blog/category/wealth-creation-portfolio-management-pms-investment-advisory/'
  },
  {
    id: 'compass',
    title: 'Compass: Personal Finance Blog',
    description: "Getting more out of your money",
    Icon: Compass,
    category: 'Blogs & Podcast',
    externalLink: "https://maxiomwealth.com/blog/category/financial-planning-money-matters-investment-advisor/"
  },
  {
    id: 'podcast',
    title: 'M2M Podcast',
    description: "Listen to M2M podcast by Manoj and Medury on market insights",
    Icon: Headphones,
    category: 'Blogs & Podcast',
    externalLink: "https://www.youtube.com/playlist?list=PLf2WkbohH-nZF4HwTcXaLWj9qbzMQrB6z"
  },
  {
    id: 'invest',
    title: 'Investment Basics Blog',
    description: 'Learn the fundamentals of investing.',
    Icon: BookOpen,
    category: 'Learning Centre',
    externalLink: "https://maxiomwealth.com/blog/category/investing-fundamentals-mutual-funds-guide/"
  },
  {
    id: 'askguru',
    title: 'Askguru',
    description: "Blog on trending topics. Q&A",
    Icon: HelpCircle,
    category: 'Learning Centre',
    externalLink: "https://maxiomwealth.com/askguru/"
  },
  {
    id: 'maxiom-academy',
    title: 'Maxiom Academy & Certification',
    description: "Get certified and test your Financial IQ",
    Icon: GraduationCap,
    category: 'Learning Centre',
    externalLink: "https://club.maxiomwealth.com/dashboard/edu_home"
  }
];

const Knowledge = () => {
  const blogsAndPodcast = KnowledgeData.filter(item => item.category === 'Blogs & Podcast');
  const learningCentre = KnowledgeData.filter(item => item.category === 'Learning Centre');

  const handleCardClick = (externalLink) => {
    window.open(externalLink, '_blank', 'noopener,noreferrer');
  };

  const renderSection = (title, items) => (
    <div className="mb-16">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-8 text-center">
        {title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto mb-6">
        {items.map((item) => {
          const IconComponent = item.Icon;
          return (
            <div
              key={item.id}
              onClick={() => handleCardClick(item.externalLink)}
              className="bg-white rounded-lg border border-gray-200 p-4 text-center cursor-pointer hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="mb-3 flex justify-center">
                <div className="w-12 h-12 bg-[#1e3a8a] rounded-full flex items-center justify-center">
                  <IconComponent className="w-6 h-6 text-white" />
                </div>
              </div>
              <h3 className="text-lg font-semibold text-[#1e3a8a] mb-2">
                {item.title}
              </h3>
              <p className="text-s leading-relaxed">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-gray-50">
        <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-20 lg:pt-28">
          {renderSection('Blogs & Podcast', blogsAndPodcast)}
          {renderSection('Learning Centre', learningCentre)}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Knowledge;